import * as THREE from "three";
import { useEffect, useCallback, useRef, useState } from "react";
import {useSitePropertiesStore} from "../../store/useGeometryPropertiesStore.js"
import { useMapStore } from "../../store/useMapStore.js";
import { useBoundingBoxStore } from "../../store/useBoundingBoxStore.js";
import { wgs84ToWebMercator } from "../../services/CoordinateTransformService.js";
import fetchRiskAreaData from "./RiskAreaqueries.js";
import PolygonPlane from "./SiteGeometry.jsx";
import RiskGebietGeometry from "./RiskgebietGeometry.jsx";
import { useSiteExportStore } from "../../store/useSiteExport.js";
import { useLayerStore } from "../../store/useLayerStore.js";
import { useGeometryTypeStore } from "../../store/useGeometryPropertiesStore.js";
import { useRiskareaPropertiesStore } from "../../store/useGeometryPropertiesStore.js";
import { CacheGeometry, LoadFromCache,GetCacheKey, ClearCache} from "../../utils/GeometryHelper.js";
import { GeometryType } from "../../constants/progress.js";

export default function RiskAreaGeometry() 
{
  const { setGeometryType } = useGeometryTypeStore();
  const geometryType = GeometryType.RISKAREA;
  const scalingFactor = useMapStore(state => state.scalingFactor);
  const [riskAreaEntities, setRiskAreaEntities] = useState([]);  
  const visibleLayers = useLayerStore((state) => state.visibleLayers);
  const updateRiskareaPropertyStore = useRiskareaPropertiesStore((state)=> state.updateRiskareaProperties);
  // const center = useMapStore(state => state.center);
  const [crs, setCrs] = useState("EPSG3857"); 
  // const zoom = useMapStore(state => state.zoom);
  const boundingBoxNE = useBoundingBoxStore(state => state.ne);
  const boundingBoxSW = useBoundingBoxStore(state => state.sw);
  const [selectedEntityId, setSelectedEntityId] = useState(null);
  const CACHE_KEY = "cacheRiskArea";
  const CACHE_VERSION = "version_1";
  const cacheKey = GetCacheKey(boundingBoxNE,boundingBoxSW,crs, CACHE_KEY,CACHE_VERSION)
      const fetchData = async () => {
      if(visibleLayers.riskGebiet)
      {
        try {
        let data = LoadFromCache (cacheKey, CACHE_VERSION, 1000 * 60 * 60 * 24) 
        if(!data)
        {
              data = await fetchRiskAreaData(
              boundingBoxNE.lng,
              boundingBoxNE.lat,
              boundingBoxSW.lng,
              boundingBoxSW.lat
            );
            
            if (data) {
            
              setRiskAreaEntities(data);
              ClearCache(CACHE_KEY);
              CacheGeometry(boundingBoxNE,boundingBoxSW,crs, CACHE_KEY, CACHE_VERSION, data)
              console.log("Number of Risk area entities recieved",data);
            
            }
        }
        else{
          setRiskAreaEntities(data);

        }
      } catch (error) {
        console.error('Failed to fetch data:', error);
        // Handle error (show notification, etc.)
      }

      }
    
    };
  useEffect(() => 
    {
      fetchData();
     // console.log(bbArray)
      
   }, [visibleLayers.riskGebiet]);
    const handleEntitySelect = (entity) => 
    {
      setSelectedEntityId(entity.id);
      setGeometryType(entity.Name);
      updateRiskareaPropertyStore(entity.objectId,entity.waterType, entity.waterName)
      
    }
     const handleBackgroundClick = () => 
    {
      setSelectedEntityId(null);
    };
 
  return (
    <>
      <group onClick={handleBackgroundClick}>
      {riskAreaEntities.length > 0 && (
      <RiskGebietGeometry 
        entities={riskAreaEntities}
        selectedEntityId={selectedEntityId}
        setSelectedEntityId={setSelectedEntityId}
        inputColor ={"#4e8499"}
        inputVisibilty={visibleLayers.riskGebiet}
        onEntitySelect={handleEntitySelect}
        className={"RiskAreaEntity"}
        crs={"EPSG3857"}
        geometryType={geometryType}
        zTransform = {[0,1,0]}
      />
    )}
    </group>
    </>
  );
}